import axios from 'axios';
import { trimPhone } from '@/utils/phone';
import { getXxTrustedFormCertUrl } from '@/utils/tcpaValidation';

interface SolarEdgeLeadSubmitData {
  first_name: string;
  last_name: string;
  phone_1: string;
  email?: string;
  postal_code: string;
  trustedform_cert_url: string;
}

export type SolarEdgeLeadInputData = Omit<
  SolarEdgeLeadSubmitData,
  'trustedform_cert_url'
>;

export interface SolarEdgeLeadResponse {
  outcome: 'failure' | 'success';
  reason?: string;
  lead: {
    id: string;
  };
  price: number;
}

const sanitizeSolarEdgeData = (
  solarEdgeData: SolarEdgeLeadInputData
): SolarEdgeLeadInputData => {
  const sanitizedData: SolarEdgeLeadInputData = {
    first_name: solarEdgeData.first_name.trim(),
    last_name: solarEdgeData.last_name.trim(),
    phone_1: trimPhone(solarEdgeData.phone_1) ?? '',
    postal_code: solarEdgeData.postal_code.trim(),
  };

  if (solarEdgeData.email?.trim()) {
    sanitizedData.email = solarEdgeData.email.trim();
  }

  return sanitizedData;
};

export function useSubmitLeadToSolarEdge() {
  async function submitLeadToSolarEdge({
    solarEdgeData,
    submissionUrl,
  }: {
    solarEdgeData: SolarEdgeLeadInputData;
    submissionUrl?: string;
  }) {
    if (!submissionUrl) {
      throw new Error('Missing SolarEdge submission URL');
    }

    const payload: SolarEdgeLeadSubmitData = {
      ...sanitizeSolarEdgeData(solarEdgeData),
      trustedform_cert_url: getXxTrustedFormCertUrl(),
    };

    const response = await axios.post<SolarEdgeLeadResponse>(
      submissionUrl,
      payload
    );
    const responseData = response.data;

    if (response.status !== 201) {
      throw new Error('SolarEdge submission failed', { cause: responseData });
    }

    return responseData;
  }

  return { submitLeadToSolarEdge };
}
